<script>
import 'animate.css'
import { WOW } from 'wowjs'
export default {
  data() {
    return {
      list1: [
        {
          icon: '<i class="icomoon icon-calender"></i>',
          title: '預約管理系統',
          content: '客戶依照自己方便的時間線上預約；管理員亦可從後台管理排程，避免重複預訂'
        },
        {
          icon: '<i class="icomoon icon-customer"></i>',
          title: '客戶管理',
          content: '集中管理客戶和他們寵物的所有資訊，隨時調閱、以寵物狀況調整服務，建立良好客戶關係！'
        },
        {
          icon: '<i class="icomoon icon-people"></i>',
          title: '員工管理',
          content: '設定每位員工可提供什麼類型的服務，清楚紀錄接待過的寵物和服務'
        },
        {
          icon: '<i class="icomoon icon-text"></i>',
          title: '簡訊通知',
          content: '減少客戶缺席狀況！自動發送預約通知，免除繁複又艱苦的聯繫提醒，每天至少可幫您節省2小時'
        },
      ],
      list2: [
        {
          icon: '<i class="icomoon icon-time"></i>',
          title: '排班管理',
          content: '單日多段彈性排班方式，滿足多元排班需求。'
        },
        {
          icon: '<i class="icomoon icon-user-permission"></i>',
          title: '管理帳號權限分級',
          content: '透過簡單的操作有效分配職位權責，掌控員工的瀏覽操作權限'
        },
        {
          icon: '<i class="icomoon icon-plan"></i>',
          title: '預付方案',
          content: '自由組合適用項目，預約時即可迅速直接做抵扣。'
        },
        {
          icon: '<i class="icomoon icon-messenger"></i>',
          title: 'Facebook messenger',
          content: '讓您和客戶的溝通多一個免費的管道！客戶服務更為順暢。'
        },
      ]
    }
  },
  mounted() { 
    this.$nextTick(() => {  
      let wow = new WOW({
        live:false
      })
      wow.init()
    })
  }
}
</script>

<template>
  <div :class="$style.sectionList" class="section">
    <div class="container">
      <BaseSectionTitle 
        title="為您的寵物美容服務帶來專業優勢！" 
        sub-title="All-in-One" 
        class="isStyleDecoration text-center isCenter mx-auto wow animate__animated animate__fadeInUp"
      />
      <div class="row justify-content-center sectionList__list list1 wow animate__animated animate__fadeInUp">
        <div
          v-for="(item, $index) in list1"
          :key="$index"
          class="col-lg-3 col-6 sectionList__item"
        >
         <BaseList :title="item.title" :icon="item.icon" :content="item.content"/>
        </div>
      </div>
       <div class="row justify-content-center sectionList__list wow animate__animated animate__fadeInUp">
        <div
          v-for="(item2, $index2) in list2"
          :key="$index2"
          class="col-lg-3 col-6 sectionList__item"
        >
         <BaseList :title="item2.title" :icon="item2.icon" :content="item2.content"/>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
  .sectionList {
    position: relative;
    &:before {
      content:'';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      background-image: url('@assets/images/intermediateplan/section4-bg2.svg');
      background-repeat: no-repeat;
      background-size: cover;
      width: 10%;
      padding-bottom: 16%;
      @include max-lg {
        display: none;
      }
    }
    &:after {
      content:url('@assets/images/intermediateplan/section4-bg.svg');
      position: absolute;
      // background-image: url('@assets/images/intermediateplan/section4-bg.svg');
      // background-repeat: no-repeat;
      // background-size: cover;
      // width: 39%;
      // padding-bottom: 59%;
      top: 0;
      right: 0;
      @include max-md {
        top: 100px;
      }
    }
    // background-image: url('@assets/images/home/section3-bg.svg');
    // background-repeat: no-repeat;
    // background-size: cover;
    // width: 100vw;
    // padding-bottom: 15%;
    :global {
      .row {
        @include max-lg {
          margin-left: -9px;
          margin-right: -9px;
        }
      }
      [class*="col-"] {
        @include max-lg {
          padding-left: 9px;
          padding-right: 9px;
        }
      }
      .sectionList {
        &__list {
          &.list1 {
            margin-top: -35px;
          }
          
        }
        &__item {
          margin-top: 75px;
        }
      }
    }
  }
</style>